/**
 * signing.commit.waitForSignatures (seed 260, Bill 2026-10-02) — whether the account
 * opening waits for required signatures. Read the same way the server reads it
 * (PCBRetailApi SigningCommitPolicy.ParseNeverWait): only an explicit wait value
 * waits; unknown or blank is the configured default, never. The signing section's
 * wording follows it (CHG-0055).
 */

export const SIGNING_COMMIT_POLICY_KEY = 'signing.commit.waitForSignatures';

const WAIT_VALUES = new Set(['all-required', 'all', 'required', 'wait', 'true']);

/** True when the accounts open without waiting for signatures (the default). */
export function openingNeverWaits(systemSettings: unknown): boolean {
  const raw = systemSettings && typeof systemSettings === 'object' && !Array.isArray(systemSettings)
    ? (systemSettings as Record<string, unknown>)[SIGNING_COMMIT_POLICY_KEY]
    : undefined;
  const v = typeof raw === 'string' ? raw.trim().toLowerCase() : '';
  return !WAIT_VALUES.has(v);
}
